import React from 'react';
import { useSelector } from 'react-redux';
import { selectCommodities } from '../../store/commoditiesSlice';

const CommoditiesList = () => {
  const commodities = useSelector(selectCommodities);

  // Sort commodities by expiryDate ascending
  const sortedCommodities = [...commodities].sort((a, b) => {
    if (!a.expiryDate) return 1;
    if (!b.expiryDate) return -1;
    return new Date(a.expiryDate) - new Date(b.expiryDate);
  });

  return (
    <div style={{ padding: 16 }}>
      <h2>Current Prices</h2>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #ddd', padding: 8 }}>Symbol</th>
            <th style={{ border: '1px solid #ddd', padding: 8 }}>Name</th>
            <th style={{ border: '1px solid #ddd', padding: 8 }}>Contract</th>
            <th style={{ border: '1px solid #ddd', padding: 8 }}>Bid</th>
            <th style={{ border: '1px solid #ddd', padding: 8 }}>Ask</th>
          </tr>
        </thead>
        <tbody>
          {sortedCommodities.map(c => (
            <tr key={c.id || c.symbol}>
              <td style={{ border: '1px solid #ddd', padding: 8 }}>{c.symbol}</td>
              <td style={{ border: '1px solid #ddd', padding: 8 }}>{c.name}</td>
              <td style={{ border: '1px solid #ddd', padding: 8 }}>{c.contractMonth && c.contractYear ? `${c.contractMonth} ${c.contractYear}` : ''}</td>
              <td style={{ border: '1px solid #ddd', padding: 8 }}>{typeof c.bid === 'number' ? c.bid.toFixed(2) : c.bid}</td>
              <td style={{ border: '1px solid #ddd', padding: 8 }}>{typeof c.ask === 'number' ? c.ask.toFixed(2) : c.ask}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CommoditiesList;
